import { LOGO_WHITE } from "../data/content";
import { scrollToId } from "../lib/scroll";

const EXPLORE = [
  { label: "Our Work", id: "work" },
  { label: "Services", id: "services" },
  { label: "About", id: "about" },
  { label: "Service Area", id: "service-area" },
  { label: "Contact", id: "contact" },
];

export const Footer = () => {
  return (
    <footer data-testid="footer" className="mt-6 bg-charcoal text-cream">
      <div className="px-6 sm:px-10 lg:px-16 pt-16 sm:pt-20 pb-32 max-w-[1700px] mx-auto">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <img src={LOGO_WHITE} alt="Nagel Landscaping" data-testid="footer-logo" className="h-10 w-auto" />
            <p className="mt-6 font-mono text-[10px] tracking-[0.2em] text-cream/45 leading-relaxed">
              CALIFORNIA CONTRACTOR<br />LICENSE #667661
            </p>
          </div>
          <div className="md:col-span-2">
            <p className="font-mono text-[10px] tracking-[0.24em] text-cream/40 mb-5">SERVICES</p>
            <ul className="space-y-3 text-sm text-cream/75">
              <li>Landscape Construction</li>
              <li>Landscape Design-Build</li>
              <li>Landscape Management</li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="font-mono text-[10px] tracking-[0.24em] text-cream/40 mb-5">EXPLORE</p>
            <ul className="space-y-3 text-sm">
              {EXPLORE.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-link-${l.id}`}
                    onClick={() => scrollToId(l.id)}
                    className="text-cream/75 hover:text-flame transition-colors duration-300"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="font-mono text-[10px] tracking-[0.24em] text-cream/40 mb-5">CONTACT</p>
            <p className="text-sm text-cream/75 leading-relaxed">
              5703A McHenry Avenue<br />Modesto, CA 95356
            </p>
            <p className="mt-4 space-y-1">
              <a data-testid="footer-phone" href="tel:+12095451696" className="block font-display font-bold text-lg text-cream hover:text-flame transition-colors duration-300">
                (209) 545-1696
              </a>
              <a data-testid="footer-email" href="mailto:info@nagellandscape.com" className="block text-sm text-cream/75 hover:text-flame transition-colors duration-300">
                info@nagellandscape.com
              </a>
            </p>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-cream/10 flex flex-wrap items-center justify-between gap-4">
          <p className="font-mono text-[10px] tracking-[0.18em] text-cream/40">© 2026 NAGEL LANDSCAPING, INC.</p>
          <div className="flex gap-6">
            <span className="font-mono text-[10px] tracking-[0.18em] text-cream/40 hover:text-cream/80 transition-colors cursor-pointer">PRIVACY POLICY</span>
            <span className="font-mono text-[10px] tracking-[0.18em] text-cream/40 hover:text-cream/80 transition-colors cursor-pointer">TERMS</span>
            <span className="font-mono text-[10px] tracking-[0.18em] text-cream/40 hover:text-cream/80 transition-colors cursor-pointer">ACCESSIBILITY</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
